import { render } from "./OnboardingBtn.vue?vue&type=template&id=12f6b500&scoped=true"
import script from "./OnboardingBtn.vue?vue&type=script&lang=js"
export * from "./OnboardingBtn.vue?vue&type=script&lang=js"

import "./OnboardingBtn.vue?vue&type=style&index=0&id=12f6b500&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f6b500"]])

export default __exports__